<template>
  <el-card>
    <el-row>
      <div style="margin-bottom: 10px">
        <el-button type="primary" icon="el-icon-plus" size="small" :disabled="selectData.length === 0" @click="addData">批量添加</el-button>
      </div>

      <el-table
          :data="tableData"
          :max-height="tableHeight"
          style="width: 100%"
          @selection-change="selectRow"
          border
      >
        <el-table-column type="selection" width="80px" align="center" label="序号"> </el-table-column>
        <el-table-column prop="companyName" align="center" label="公司名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="brandName" align="center" label="品牌名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" align="center" label="产品名称" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="picture" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                v-if="scope.row.logoSrc"
                style="width: auto;height: 20px"
                :src="scope.row.logoSrc"
                :preview-src-list="scope.row.logoList"
                fit="contain"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="reason" align="center" label="状态"> </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
                size="mini"
                icon="el-icon-plus"
                type="text"
                @click="addItem(scope.row.id)"
            >添加</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes"
          :total="total"
      >
      </el-pagination>
    </el-row>
  </el-card>
</template>

<script>

export default {
  name: 'index',
  data () {
    return {
      recordId: '',
      tableData: [],
      tableHeight: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      selectData: []
    }
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 500
  },
  methods: {
    async getPageList (id) {
      this.recordId = id
      let {data: res} = await this.$http.post('/meetBrandProduct/getPageList', {
        recordId: this.recordId,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === '200') {
        this.tableData = res.data.records
        this.tableData.forEach(item => {
          if (item.picture) {
            item.logoList = item.picture.split(',')
            item.logoSrc = item.picture.split(',')[0]
          } else {
            item.logoSrc = ''
            item.logoList = []
          }
        })
        this.total = Number(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList(this.recordId)
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList(this.recordId)
    },
    selectRow (selection) {
      this.selectData = selection
    },
    save (params) {
      this.$http
        .post('/meetBrandProduct/add', params)
        .then((res) => {
          if (res.data.code === '200') {
            this.$message.success('添加成功!')
            this.$emit('success')
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '添加失败'
          })
        })
    },
    addItem (id) {
      const params = [
        {
          sourceId: id,
          recordId: this.recordId
        }
      ]
      this.save(params)
    },
    addData () {
      this.$confirm(
        `确认添加选中的${this.selectData.length}条数据?`,
        '删除提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          showClose: false
        }
      )
        .then(() => {
          const params = this.selectData.map((item) => {
            return {
              sourceId: item.id,
              recordId: this.recordId
            }
          })
          this.save(params)
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/meetSession/meetBrandProductList.vue